import { render, staticRenderFns } from "./BemVindo.vue?vue&type=template&id=df989190&scoped=true"
import script from "./BemVindo.vue?vue&type=script&lang=js"
export * from "./BemVindo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df989190",
  null
  
)

export default component.exports